import { useTenant } from '@emerald-works-nova/auth'
import React, { useEffect, useMemo } from 'react'
import { RouterProvider } from 'react-router-dom'
import consts from '../consts'
import { isContentOnlyTenantLayout } from '../utils/contentOnlyLayout'
import { consumerRouter } from './consumer-router'
import { contentOnlyRouter } from './content-only-router'
import { enterpriseRouter } from './enterprise-router'

export const ApplicationRouterProvider = ({ onChangeMainColor }) => {
  const tenant = useTenant()

  const router = useMemo(() => {
    if (!tenant) return null

    if (isContentOnlyTenantLayout(tenant.tenantKey)) {
      return contentOnlyRouter
    }

    if (tenant.pk === consts.DEFAULT_CLUB_PK) {
      return consumerRouter
    }

    return enterpriseRouter
  }, [tenant])

  useEffect(() => {
    if (tenant && tenant.mainColor) {
      onChangeMainColor(tenant.mainColor)
    }
  }, [tenant, onChangeMainColor])

  if (!tenant) return null

  return (
    <RouterProvider
      router={router}
    />
  )
}
